const alphabetData = [
  {
    "letter": "aa",
    "harf": "آ",
    "soundFile": "aa.mp3",
    "words": [
      {
        "word": "آئینہ",
        "imageFile": "aa_01.jpg",
        "soundFile": "aa_01.mp3",
        "videoFile": "aa_11.webm",
        "icon": "GiMirrorMirror",
        "sfxFile": "sfx/mirror-shimmer.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "object",
          "household"
        ]
      },
      {
        "word": "آگ",
        "imageFile": "aa_02.jpg",
        "soundFile": "aa_02.mp3",
        "videoFile": "aa_12.webm",
        "icon": "GiFlame",
        "sfxFile": "sfx/fire-crackle.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "element",
          "danger",
          "nature"
        ]
      },
      {
        "word": "آسمان",
        "imageFile": "aa_03.jpg",
        "soundFile": "aa_03.mp3",
        "videoFile": "aa_13.webm",
        "icon": "WiDaySunny",
        "sfxFile": "sfx/sky-breeze.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "nature",
          "sky"
        ]
      },
      {
        "word": "آری",
        "imageFile": "aa_04.jpg",
        "soundFile": "aa_04.mp3",
        "videoFile": "aa_14.webm",
        "icon": "GiSawblade",
        "sfxFile": "sfx/tool-saw.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "tool",
          "object"
        ]
      },
      {
        "word": "آلو",
        "imageFile": "aa_05.jpg",
        "soundFile": "aa_05.mp3",
        "videoFile": "aa_15.webm",
        "icon": "GiPotato",
        "sfxFile": "sfx/vegetable.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "vegetable",
          "food"
        ]
      },
      {
        "word": "آم",
        "imageFile": "aa_06.jpg",
        "soundFile": "aa_06.mp3",
        "icon": "GiMango",
        "sfxFile": "sfx/mango-bite.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "fruit",
          "food"
        ]
      }
    ]
  },
  {
    "letter": "alif",
    "harf": "ا",
    "soundFile": "alif.mp3",
    "words": [
      {
        "word": "اکیلا",
        "imageFile": "alif_01.jpg",
        "soundFile": "alif_01.mp3",
        "videoFile": "alif_11.webm",
        "icon": "FaUserAlt",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "concept",
          "feeling"
        ]
      },
      {
        "word": "اصطبل",
        "imageFile": "alif_02.jpg",
        "soundFile": "alif_02.mp3",
        "videoFile": "alif_12.webm",
        "icon": "GiStable",
        "sfxFile": "sfx/horse-neigh.mp3",
        "categories": [
          "place",
          "animal",
          "farm"
        ]
      },
      {
        "word": "افریقہ",
        "imageFile": "alif_03.jpg",
        "soundFile": "alif_03.mp3",
        "videoFile": "alif_13.webm",
        "icon": "GiAfrica",
        "sfxFile": "sfx/tribal-drum.mp3",
        "categories": [
          "place",
          "continent",
          "foreign"
        ]
      },
      {
        "word": "اژدھا",
        "imageFile": "alif_04.jpg",
        "soundFile": "alif_04.mp3",
        "videoFile": "alif_14.webm",
        "icon": "GiSnake",
        "sfxFile": "sfx/snake-hiss.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "animal",
          "reptile",
          "danger"
        ]
      },
      {
        "word": "ادرک",
        "imageFile": "alif_05.jpg",
        "soundFile": "alif_05.mp3",
        "videoFile": "alif_15.webm",
        "sfxFile": "sfx/vegetable.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "vegetable",
          "spice",
          "food"
        ]
      },
      {
        "word": "انار",
        "imageFile": "alif_06.jpg",
        "soundFile": "alif_06.mp3",
        "sfxFile": "sfx/fruit-pop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "fruit",
          "food"
        ]
      }
    ]
  },
  {
    "letter": "bay",
    "harf": "ب",
    "soundFile": "bay.mp3",
    "words": [
      {
        "word": "بس",
        "imageFile": "bay_01.jpg",
        "soundFile": "bay_01.mp3",
        "videoFile": "bay_11.webm",
        "icon": "FaBus",
        "sfxFile": "sfx/bus-horn.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "transport",
          "vehicle"
        ]
      },
      {
        "word": "بستہ",
        "imageFile": "bay_02.jpg",
        "soundFile": "bay_02.mp3",
        "icon": "FaSchool",
        "sfxFile": "sfx/bag-zip.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "object",
          "school",
          "stationery"
        ]
      },
      {
        "word": "بندرگاہ",
        "imageFile": "bay_03.jpg",
        "soundFile": "bay_03.mp3",
        "videoFile": "bay_13.webm",
        "icon": "GiHarborDock",
        "sfxFile": "sfx/ship-horn.mp3",
        "categories": [
          "place",
          "transport",
          "infrastructure"
        ]
      },
      {
        "word": "بلی",
        "imageFile": "bay_04.jpg",
        "soundFile": "bay_04.mp3",
        "videoFile": "bay_14.webm",
        "icon": "FaCat",
        "sfxFile": "sfx/cat-meow.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "animal",
          "pet"
        ]
      },
      {
        "word": "بینگن",
        "imageFile": "bay_05.jpg",
        "soundFile": "bay_05.mp3",
        "videoFile": "bay_15.webm",
        "icon": "GiEggplant",
        "sfxFile": "sfx/vegetable.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ],
        "categories": [
          "vegetable",
          "food"
        ]
      },
      {
        "word": "بادام",
        "imageFile": "bay_06.jpg",
        "soundFile": "bay_06.mp3",
        "videoFile": "bay_16.webm",
        "icon": "GiAlmond",
        "sfxFile": "sfx/almond-crack.mp3",
        "categories": [
          "food",
          "nut",
          "plant"
        ]
      }
    ]
  },
  {
    "letter": "pay",
    "harf": "پ",
    "soundFile": "pay.mp3",
    "words": [
      {
        "word": "پہلوان",
        "imageFile": "pay_01.jpg",
        "soundFile": "pay_01.mp3",
        "videoFile": "pay_11.webm",
        "icon": "GiMuscleUp",
        "sfxFile": "sfx/punch.mp3",
        "categories": [
          "person",
          "sports"
        ]
      },
      {
        "word": "پتنگ",
        "imageFile": "pay_02.jpg",
        "soundFile": "pay_02.mp3",
        "videoFile": "pay_12.webm",
        "sfxFile": "sfx/kite-flap.mp3",
        "categories": [
          "toy",
          "object",
          "festival"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پشاور",
        "imageFile": "pay_03.jpg",
        "soundFile": "pay_03.mp3",
        "categories": [
          "place",
          "city",
          "local"
        ]
      },
      {
        "word": "پانڈا",
        "imageFile": "pay_04.jpg",
        "soundFile": "pay_04.mp3",
        "videoFile": "pay_14.webm",
        "icon": "GiPanda",
        "sfxFile": "sfx/panda.mp3",
        "categories": [
          "animal",
          "mammal"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پالک",
        "imageFile": "pay_05.jpg",
        "soundFile": "pay_05.mp3",
        "sfxFile": "sfx/leaf-rustle.mp3",
        "categories": [
          "vegetable",
          "food",
          "plant"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پپیتا",
        "imageFile": "pay_06.jpg",
        "soundFile": "pay_06.mp3",
        "sfxFile": "sfx/fruit-pop.mp3",
        "categories": [
          "fruit",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "tay",
    "harf": "ت",
    "soundFile": "tay.mp3",
    "words": [
      {
        "word": "تالا",
        "imageFile": "tay_01.jpg",
        "soundFile": "tay_01.mp3",
        "icon": "GiPadlock",
        "sfxFile": "sfx/lock-click.mp3",
        "categories": [
          "object",
          "tool",
          "security"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "تولیہ",
        "imageFile": "tay_02.jpg",
        "soundFile": "tay_02.mp3",
        "icon": "GiTowel",
        "sfxFile": "sfx/fabric-swish.mp3",
        "categories": [
          "object",
          "household"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ترکی",
        "imageFile": "tay_03.jpg",
        "soundFile": "tay_03.mp3",
        "sfxFile": "sfx/gobble.mp3",
        "categories": [
          "place",
          "country",
          "foreign"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "تتلی",
        "imageFile": "tay_04.jpg",
        "soundFile": "tay_04.mp3",
        "videoFile": "tay_14.webm",
        "icon": "GiButterfly",
        "sfxFile": "sfx/wings-flutter.mp3",
        "categories": [
          "animal",
          "insect",
          "nature"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ترئی",
        "imageFile": "tay_05.jpg",
        "soundFile": "tay_05.mp3",
        "sfxFile": "sfx/slice.mp3",
        "categories": [
          "vegetable",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "تربوز",
        "imageFile": "tay_06.jpg",
        "soundFile": "tay_06.mp3",
        "icon": "GiWatermelon",
        "sfxFile": "sfx/fruit-slice.mp3",
        "categories": [
          "fruit",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "ttay",
    "harf": "ٹ",
    "soundFile": "ttay.mp3",
    "words": [
      {
        "word": "ٹرک",
        "imageFile": "ttay_01.jpg",
        "soundFile": "ttay_01.mp3",
        "icon": "FaTruck",
        "sfxFile": "sfx/truck-horn.mp3",
        "categories": [
          "transport",
          "vehicle"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹیلیفون",
        "imageFile": "ttay_02.jpg",
        "soundFile": "ttay_02.mp3",
        "videoFile": "ttay_12.webm",
        "icon": "FaPhoneAlt",
        "sfxFile": "sfx/phone-ring.mp3",
        "categories": [
          "object",
          "technology",
          "communication"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹوکیو",
        "imageFile": "ttay_03.jpg",
        "soundFile": "ttay_03.mp3",
        "icon": "GiJapan",
        "sfxFile": "sfx/city-chime.mp3",
        "categories": [
          "place",
          "city",
          "foreign"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹڈا",
        "imageFile": "ttay_04.jpg",
        "soundFile": "ttay_04.mp3",
        "videoFile": "ttay_14.webm",
        "sfxFile": "sfx/insect-buzz.mp3",
        "categories": [
          "animal",
          "insect"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹوکری",
        "imageFile": "ttay_05.jpg",
        "soundFile": "ttay_05.mp3",
        "videoFile": "ttay_15.webm",
        "icon": "GiBasket",
        "sfxFile": "sfx/basket-drop.mp3",
        "categories": [
          "object",
          "household",
          "container"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹماٹر",
        "imageFile": "ttay_06.jpg",
        "soundFile": "ttay_06.mp3",
        "videoFile": "ttay_16.webm",
        "icon": "GiTomato",
        "sfxFile": "sfx/squish.mp3",
        "categories": [
          "vegetable",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "say",
    "harf": "ث",
    "soundFile": "say.mp3",
    "words": [
      {
        "word": "ثقافت",
        "imageFile": "say_01.jpg",
        "soundFile": "say_01.mp3",
        "videoFile": "say_11.webm",
        "sfxFile": "sfx/page-flip.mp3",
        "categories": [
          "concept",
          "culture"
        ]
      },
      {
        "word": "ثابت",
        "imageFile": "say_02.jpg",
        "soundFile": "say_02.mp3",
        "sfxFile": "sfx/confirm.mp3",
        "categories": [
          "concept",
          "quality"
        ]
      },
      {
        "word": "ثریا",
        "imageFile": "say_03.jpg",
        "soundFile": "say_03.mp3",
        "videoFile": "say_13.webm",
        "icon": "GiStarsStack",
        "sfxFile": "sfx/twinkle.mp3",
        "categories": [
          "name",
          "person"
        ]
      },
      {
        "word": "ثور",
        "imageFile": "say_04.jpg",
        "soundFile": "say_04.mp3",
        "icon": "GiBullHorns",
        "sfxFile": "sfx/bull-snort.mp3",
        "categories": [
          "name",
          "mythology",
          "animal"
        ]
      },
      {
        "word": "ثلث",
        "imageFile": "say_05.jpg",
        "soundFile": "say_05.mp3",
        "videoFile": "say_15.webm",
        "sfxFile": "sfx/click.mp3",
        "categories": [
          "concept",
          "math"
        ]
      },
      {
        "word": "ثمر",
        "imageFile": "say_06.jpg",
        "soundFile": "say_06.mp3",
        "icon": "GiGrapes",
        "sfxFile": "sfx/fruit-pop.mp3",
        "categories": [
          "fruit",
          "food",
          "plant"
        ]
      }
    ]
  },
  {
    "letter": "jeem",
    "harf": "ج",
    "soundFile": "jeem.mp3",
    "words": [
      {
        "word": "جلسہ",
        "imageFile": "jeem_01.jpg",
        "soundFile": "jeem_01.mp3",
        "categories": [
          "event",
          "gathering"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "جہاز",
        "imageFile": "jeem_02.jpg",
        "soundFile": "jeem_02.mp3",
        "videoFile": "jeem_12.webm",
        "icon": "GiAirplaneDeparture",
        "sfxFile": "sfx/plane-takeoff.mp3",
        "categories": [
          "transport",
          "vehicle",
          "air"
        ]
      },
      {
        "word": "جزیرہ",
        "imageFile": "jeem_03.jpg",
        "soundFile": "jeem_03.mp3",
        "videoFile": "jeem_13.webm",
        "icon": "GiPalmTree",
        "sfxFile": "sfx/waves.mp3",
        "categories": [
          "place",
          "nature",
          "geography"
        ]
      },
      {
        "word": "جگنو",
        "imageFile": "jeem_04.jpg",
        "soundFile": "jeem_04.mp3",
        "videoFile": "jeem_14.webm",
        "icon": "GiFirefly",
        "sfxFile": "sfx/light-spark.mp3",
        "categories": [
          "animal",
          "insect",
          "nature"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "جَو",
        "imageFile": "jeem_05.jpg",
        "soundFile": "jeem_05.mp3",
        "icon": "GiWheat",
        "sfxFile": "sfx/grain-pour.mp3",
        "categories": [
          "food",
          "grain",
          "plant"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "جامن",
        "imageFile": "jeem_06.jpg",
        "soundFile": "jeem_06.mp3",
        "sfxFile": "sfx/fruit-drop.mp3",
        "categories": [
          "fruit",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "chay",
    "harf": "چ",
    "soundFile": "chay.mp3",
    "words": [
      {
        "word": "چابی",
        "imageFile": "chay_01.jpg",
        "soundFile": "chay_01.mp3",
        "videoFile": "chay_11.webm",
        "icon": "GiKey",
        "sfxFile": "sfx/key-jingle.mp3",
        "categories": [
          "object",
          "tool",
          "security"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چاقو",
        "imageFile": "chay_02.jpg",
        "soundFile": "chay_02.mp3",
        "icon": "GiKitchenKnives",
        "sfxFile": "sfx/knife-slice.mp3",
        "categories": [
          "tool",
          "kitchen",
          "object"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چاند",
        "imageFile": "chay_03.jpg",
        "soundFile": "chay_03.mp3",
        "videoFile": "chay_13.webm",
        "icon": "GiMoon",
        "sfxFile": "sfx/moon-glow.mp3",
        "categories": [
          "nature",
          "space",
          "object"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چیتا",
        "imageFile": "chay_04.jpg",
        "soundFile": "chay_04.mp3",
        "videoFile": "chay_14.webm",
        "sfxFile": "sfx/tiger-growl.mp3",
        "categories": [
          "animal",
          "wildlife",
          "mammal"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چقندر",
        "imageFile": "chay_05.jpg",
        "soundFile": "chay_05.mp3",
        "sfxFile": "sfx/vegetable.mp3",
        "categories": [
          "vegetable",
          "food",
          "plant"
        ]
      },
      {
        "word": "چیکو",
        "imageFile": "chay_06.jpg",
        "soundFile": "chay_06.mp3",
        "sfxFile": "sfx/fruit-drop.mp3",
        "categories": [
          "fruit",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "hay",
    "harf": "ح",
    "soundFile": "hay.mp3",
    "words": [
      {
        "word": "حجام",
        "imageFile": "hay_01.jpg",
        "soundFile": "hay_01.mp3",
        "videoFile": "hay_11.webm",
        "sfxFile": "sfx/scissors.mp3",
        "categories": [
          "person",
          "occupation",
          "service"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "حلوائی",
        "imageFile": "hay_02.jpg",
        "soundFile": "hay_02.mp3",
        "videoFile": "hay_12.webm",
        "sfxFile": "sfx/serve.mp3",
        "categories": [
          "person",
          "occupation",
          "food"
        ]
      },
      {
        "word": "حویلی",
        "imageFile": "hay_03.jpg",
        "soundFile": "hay_03.mp3",
        "videoFile": "hay_13.webm",
        "icon": "GiCastle",
        "sfxFile": "sfx/door-creak.mp3",
        "categories": [
          "place",
          "building",
          "home"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "حشرات الارض",
        "imageFile": "hay_04.jpg",
        "soundFile": "hay_04.mp3",
        "videoFile": "hay_14.webm",
        "sfxFile": "sfx/insect-buzz.mp3",
        "categories": [
          "animal",
          "insect",
          "group"
        ]
      },
      {
        "word": "حوض",
        "imageFile": "hay_05.jpg",
        "soundFile": "hay_05.mp3",
        "icon": "GiFountain",
        "sfxFile": "sfx/water-bubble.mp3",
        "categories": [
          "place",
          "water",
          "structure"
        ]
      },
      {
        "word": "حلوہ",
        "imageFile": "hay_06.jpg",
        "soundFile": "hay_06.mp3",
        "icon": "GiHoneyJar",
        "sfxFile": "sfx/spoon-swish.mp3",
        "categories": [
          "food",
          "dessert",
          "sweet"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "khay",
    "harf": "خ",
    "soundFile": "khay.mp3",
    "words": [
      {
        "word": "خلاباز",
        "imageFile": "khay_01.jpg",
        "soundFile": "khay_01.mp3",
        "videoFile": "khay_11.webm",
        "icon": "GiAstronautHelmet",
        "sfxFile": "sfx/space-blip.mp3",
        "categories": [
          "person",
          "occupation",
          "space"
        ]
      },
      {
        "word": "خیمہ",
        "imageFile": "khay_02.jpg",
        "soundFile": "khay_02.mp3",
        "videoFile": "khay_12.webm",
        "icon": "GiCampingTent",
        "sfxFile": "sfx/zipper.mp3",
        "categories": [
          "object",
          "shelter",
          "temporary"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "خیبر پختونخواہ",
        "imageFile": "khay_03.jpg",
        "soundFile": "khay_03.mp3",
        "sfxFile": "sfx/mountain-wind.mp3",
        "categories": [
          "place",
          "province",
          "local"
        ]
      },
      {
        "word": "خرگوش",
        "imageFile": "khay_04.jpg",
        "soundFile": "khay_04.mp3",
        "icon": "GiRabbit",
        "sfxFile": "sfx/rabbit-hop.mp3",
        "categories": [
          "animal",
          "pet",
          "mammal"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "خوبانی",
        "imageFile": "khay_05.jpg",
        "soundFile": "khay_05.mp3",
        "icon": "GiPeach",
        "sfxFile": "sfx/fruit-pop.mp3",
        "categories": [
          "fruit",
          "food"
        ]
      },
      {
        "word": "خربوزہ",
        "imageFile": "khay_06.jpg",
        "soundFile": "khay_06.mp3",
        "icon": "GiWatermelon",
        "sfxFile": "sfx/fruit-slice.mp3",
        "categories": [
          "fruit",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "daal",
    "harf": "د",
    "soundFile": "daal.mp3",
    "words": [
      {
        "word": "درزی",
        "imageFile": "daal_01.jpg",
        "soundFile": "daal_01.mp3",
        "videoFile": "daal_11.webm",
        "icon": "GiThreadSpool",
        "sfxFile": "sfx/stitch.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "درخت",
        "imageFile": "daal_02.jpg",
        "soundFile": "daal_02.mp3",
        "icon": "GiTreeBranch",
        "sfxFile": "sfx/leaves.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "دریا",
        "imageFile": "daal_03.jpg",
        "soundFile": "daal_03.mp3",
        "videoFile": "daal_13.webm",
        "icon": "GiRiver",
        "sfxFile": "sfx/water-flow.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "دنبہ",
        "imageFile": "daal_04.jpg",
        "soundFile": "daal_04.mp3",
        "icon": "GiRam",
        "sfxFile": "sfx/sheep-bleat.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "دستانہ",
        "imageFile": "daal_05.jpg",
        "soundFile": "daal_05.mp3",
        "icon": "GiGloves",
        "sfxFile": "sfx/cloth-flap.mp3"
      },
      {
        "word": "دروازہ",
        "imageFile": "daal_06.jpg",
        "soundFile": "daal_06.mp3",
        "videoFile": "daal_16.webm",
        "icon": "GiDoor",
        "sfxFile": "sfx/door-creak.mp3"
      }
    ]
  },
  {
    "letter": "ddaal",
    "harf": "ڈ",
    "soundFile": "ddaal.mp3",
    "words": [
      {
        "word": "ڈاکیہ",
        "imageFile": "ddaal_01.jpg",
        "soundFile": "ddaal_01.mp3",
        "videoFile": "ddaal_11.webm",
        "icon": "FaMailBulk",
        "sfxFile": "sfx/mail-pop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ڈاڑھی",
        "imageFile": "ddaal_02.jpg",
        "soundFile": "ddaal_02.mp3",
        "icon": "GiBeard",
        "sfxFile": "sfx/beard-rub.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ڈاکخانہ",
        "imageFile": "ddaal_03.jpg",
        "soundFile": "ddaal_03.mp3",
        "videoFile": "ddaal_13.webm",
        "icon": "FaEnvelope",
        "sfxFile": "sfx/mailbox.mp3"
      },
      {
        "word": "ڈبہ",
        "imageFile": "ddaal_04.jpg",
        "soundFile": "ddaal_04.mp3",
        "icon": "GiCardboardBox",
        "sfxFile": "sfx/box-close.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ڈور",
        "imageFile": "ddaal_05.jpg",
        "soundFile": "ddaal_05.mp3",
        "videoFile": "ddaal_15.webm",
        "icon": "GiRopeCoil",
        "sfxFile": "sfx/rope.mp3"
      },
      {
        "word": "ڈاکٹر",
        "imageFile": "ddaal_06.jpg",
        "soundFile": "ddaal_06.mp3",
        "videoFile": "ddaal_16.webm",
        "icon": "FaUserMd",
        "sfxFile": "sfx/heartbeat.mp3"
      }
    ]
  },
  {
    "letter": "zaal",
    "harf": "ذ",
    "soundFile": "zaal.mp3",
    "words": [
      {
        "word": "ذائقہ",
        "imageFile": "zaal_01.jpg",
        "soundFile": "zaal_01.mp3",
        "videoFile": "zaal_11.webm",
        "icon": "GiForkKnifeSpoon",
        "sfxFile": "sfx/taste-pop.mp3"
      },
      {
        "word": "ذرات",
        "imageFile": "zaal_02.jpg",
        "soundFile": "zaal_02.mp3",
        "videoFile": "zaal_12.webm",
        "icon": "GiChemicalDrop",
        "sfxFile": "sfx/sparkle.mp3"
      },
      {
        "word": "ذو الحجۃ",
        "imageFile": "zaal_03.jpg",
        "soundFile": "zaal_03.mp3",
        "sfxFile": "sfx/prayer-chime.mp3"
      },
      {
        "word": "ذیل",
        "imageFile": "zaal_04.jpg",
        "soundFile": "zaal_04.mp3",
        "videoFile": "zaal_14.webm",
        "sfxFile": "sfx/page-flip.mp3"
      },
      {
        "word": "ذخیرہ",
        "imageFile": "zaal_05.jpg",
        "soundFile": "zaal_05.mp3",
        "videoFile": "zaal_15.webm",
        "icon": "GiStack",
        "sfxFile": "sfx/swoosh.mp3"
      },
      {
        "word": "ذریعہ",
        "imageFile": "zaal_06.jpg",
        "soundFile": "zaal_06.mp3",
        "icon": "GiRoad",
        "sfxFile": "sfx/jump.mp3"
      }
    ]
  },
  {
    "letter": "ray",
    "harf": "ر",
    "soundFile": "ray.mp3",
    "words": [
      {
        "word": "رات",
        "imageFile": "ray_01.jpg",
        "soundFile": "ray_01.mp3",
        "videoFile": "ray_11.webm",
        "icon": "GiNightSky",
        "sfxFile": "sfx/night.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "رکشہ",
        "imageFile": "ray_02.jpg",
        "soundFile": "ray_02.mp3",
        "videoFile": "ray_12.webm",
        "icon": "GiAutoRickshaw",
        "sfxFile": "sfx/horn.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "راستہ",
        "imageFile": "ray_03.jpg",
        "soundFile": "ray_03.mp3",
        "icon": "GiPathDistance",
        "sfxFile": "sfx/footsteps.mp3"
      },
      {
        "word": "ریچھ",
        "imageFile": "ray_04.jpg",
        "soundFile": "ray_04.mp3",
        "videoFile": "ray_14.webm",
        "icon": "GiBearFace",
        "sfxFile": "sfx/bear-growl.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "راکھ",
        "imageFile": "ray_05.jpg",
        "soundFile": "ray_05.mp3",
        "icon": "GiAshPile",
        "sfxFile": "sfx/fire-fade.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ریل گاڑی",
        "imageFile": "ray_06.jpg",
        "soundFile": "ray_06.mp3",
        "videoFile": "ray_16.webm",
        "icon": "GiTrain",
        "sfxFile": "sfx/train-whistle.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "day",
    "harf": "ڑ",
    "soundFile": "dday.mp3",
    "words": [
      {
        "word": "ریوڑ",
        "imageFile": "day_01.jpg",
        "soundFile": "day_01.mp3",
        "icon": "GiCow",
        "sfxFile": "sfx/cow-moo.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "سڑک",
        "imageFile": "day_02.jpg",
        "soundFile": "day_02.mp3",
        "videoFile": "day_12.webm",
        "icon": "GiRoad",
        "sfxFile": "sfx/car-pass.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پہاڑ",
        "imageFile": "day_03.jpg",
        "soundFile": "day_03.mp3",
        "icon": "GiMountainCave",
        "sfxFile": "sfx/wind.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چڑیا",
        "imageFile": "day_04.jpg",
        "soundFile": "day_04.mp3",
        "videoFile": "day_14.webm",
        "icon": "GiBirdTwitter",
        "sfxFile": "sfx/bird-chirp.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پکوڑے",
        "imageFile": "day_05.jpg",
        "soundFile": "day_05.mp3",
        "sfxFile": "sfx/fry.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پاپڑ",
        "imageFile": "day_06.jpg",
        "soundFile": "day_06.mp3",
        "icon": "GiTacos",
        "sfxFile": "sfx/crunch.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "zay",
    "harf": "ز",
    "soundFile": "zay.mp3",
    "words": [
      {
        "word": "زردی",
        "imageFile": "zay_01.jpg",
        "soundFile": "zay_01.mp3",
        "icon": "GiEgg",
        "sfxFile": "sfx/egg-pop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "زنجیر",
        "imageFile": "zay_02.jpg",
        "soundFile": "zay_02.mp3",
        "icon": "GiChain",
        "sfxFile": "sfx/chain-rattle.mp3"
      },
      {
        "word": "زمین",
        "imageFile": "zay_03.jpg",
        "soundFile": "zay_03.mp3",
        "videoFile": "zay_13.webm",
        "icon": "GiEarthAsiaOceania",
        "sfxFile": "sfx/rumble.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "زرافہ",
        "imageFile": "zay_04.jpg",
        "soundFile": "zay_04.mp3",
        "videoFile": "zay_14.webm",
        "icon": "GiGiraffe",
        "sfxFile": "sfx/giraffe.mp3"
      },
      {
        "word": "زیرہ",
        "imageFile": "zay_05.jpg",
        "soundFile": "zay_05.mp3",
        "sfxFile": "sfx/grind.mp3"
      },
      {
        "word": "زیتون",
        "imageFile": "zay_06.jpg",
        "soundFile": "zay_06.mp3",
        "videoFile": "zay_16.webm",
        "icon": "GiOlive",
        "sfxFile": "sfx/olive-pop.mp3"
      }
    ]
  },
  {
    "letter": "zhay",
    "harf": "ژ",
    "soundFile": "zhay.mp3",
    "words": [
      {
        "word": "ژولیدہ",
        "imageFile": "zhay_01.jpg",
        "soundFile": "zhay_01.mp3",
        "sfxFile": "sfx/scribble.mp3"
      },
      {
        "word": "ژالہ باری",
        "imageFile": "zhay_02.jpg",
        "soundFile": "zhay_02.mp3",
        "videoFile": "zhay_12.webm",
        "icon": "GiHailstone",
        "sfxFile": "sfx/hail.mp3"
      },
      {
        "word": "ژولیدہ حال",
        "imageFile": "zhay_03.jpg",
        "soundFile": "zhay_03.mp3",
        "videoFile": "zhay_13.webm",
        "sfxFile": "sfx/whimper.mp3"
      },
      {
        "word": "اژدھا",
        "imageFile": "zhay_04.jpg",
        "soundFile": "zhay_04.mp3",
        "icon": "GiSnake",
        "sfxFile": "sfx/snake-hiss.mp3",
        "categories": [
          "animal",
          "reptile",
          "danger"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "اژدھام",
        "imageFile": "zhay_05.jpg",
        "soundFile": "zhay_05.mp3",
        "videoFile": "zhay_15.webm",
        "sfxFile": "sfx/crowd.mp3"
      },
      {
        "word": "ٹیلیویژن",
        "imageFile": "zhay_06.jpg",
        "soundFile": "zhay_06.mp3",
        "icon": "GiTelevision",
        "sfxFile": "sfx/tv-static.mp3"
      }
    ]
  },
  {
    "letter": "seen",
    "harf": "س",
    "soundFile": "seen.mp3",
    "words": [
      {
        "word": "سجدہ",
        "imageFile": "seen_01.jpg",
        "soundFile": "seen_01.mp3",
        "videoFile": "seen_11.webm",
        "sfxFile": "sfx/peace.mp3"
      },
      {
        "word": "سائیکل",
        "imageFile": "seen_02.jpg",
        "soundFile": "seen_02.mp3",
        "videoFile": "seen_12.webm",
        "icon": "GiBicycle",
        "sfxFile": "sfx/bike-bell.mp3"
      },
      {
        "word": "سمندر",
        "imageFile": "seen_03.jpg",
        "soundFile": "seen_03.mp3",
        "icon": "GiWaveSurfer",
        "sfxFile": "sfx/ocean.mp3"
      },
      {
        "word": "سانپ",
        "imageFile": "seen_04.jpg",
        "soundFile": "seen_04.mp3",
        "icon": "GiCobra",
        "sfxFile": "sfx/snake.mp3"
      },
      {
        "word": "سبزیاں",
        "imageFile": "seen_05.jpg",
        "soundFile": "seen_05.mp3",
        "videoFile": "seen_15.webm",
        "icon": "GiBroccoli",
        "sfxFile": "sfx/chop.mp3"
      },
      {
        "word": "سیب",
        "imageFile": "seen_06.jpg",
        "soundFile": "seen_06.mp3",
        "icon": "GiApple",
        "sfxFile": "sfx/apple-crunch.mp3"
      }
    ]
  },
  {
    "letter": "sheen",
    "harf": "ش",
    "soundFile": "sheen.mp3",
    "words": [
      {
        "word": "شکر",
        "imageFile": "sheen_01.jpg",
        "soundFile": "sheen_01.mp3",
        "sfxFile": "sfx/sugar.mp3"
      },
      {
        "word": "شمع",
        "imageFile": "sheen_02.jpg",
        "soundFile": "sheen_02.mp3",
        "videoFile": "sheen_12.webm",
        "icon": "GiCandleLight",
        "sfxFile": "sfx/flame.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "شہد",
        "imageFile": "sheen_03.jpg",
        "soundFile": "sheen_03.mp3",
        "videoFile": "sheen_13.webm",
        "icon": "GiHoneyJar",
        "sfxFile": "sfx/honey-drop.mp3"
      },
      {
        "word": "شیر",
        "imageFile": "sheen_04.jpg",
        "soundFile": "sheen_04.mp3",
        "videoFile": "sheen_14.webm",
        "icon": "GiLion",
        "sfxFile": "sfx/lion-roar.mp3"
      },
      {
        "word": "شلجم",
        "imageFile": "sheen_05.jpg",
        "soundFile": "sheen_05.mp3",
        "icon": "GiTurnip",
        "sfxFile": "sfx/vegetable.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "شریفا",
        "imageFile": "sheen_06.jpg",
        "soundFile": "sheen_06.mp3",
        "sfxFile": "sfx/fruit-pop.mp3"
      }
    ]
  },
  {
    "letter": "suad",
    "harf": "ص",
    "soundFile": "suad.mp3",
    "words": [
      {
        "word": "صف",
        "imageFile": "suad_01.jpg",
        "soundFile": "suad_01.mp3",
        "sfxFile": "sfx/page-turn.mp3"
      },
      {
        "word": "صابن",
        "imageFile": "suad_02.jpg",
        "soundFile": "suad_02.mp3",
        "videoFile": "suad_12.webm",
        "icon": "GiSoap",
        "sfxFile": "sfx/soap.mp3"
      },
      {
        "word": "صحرا",
        "imageFile": "suad_03.jpg",
        "soundFile": "suad_03.mp3",
        "videoFile": "suad_13.webm",
        "icon": "GiDesert",
        "sfxFile": "sfx/wind.mp3"
      },
      {
        "word": "صندوق",
        "imageFile": "suad_04.jpg",
        "soundFile": "suad_04.mp3",
        "icon": "GiTreasureMap",
        "sfxFile": "sfx/chest.mp3"
      },
      {
        "word": "صبح",
        "imageFile": "suad_05.jpg",
        "soundFile": "suad_05.mp3",
        "icon": "GiSunrise",
        "sfxFile": "sfx/birds.mp3"
      },
      {
        "word": "صحیح",
        "imageFile": "suad_06.jpg",
        "soundFile": "suad_06.mp3",
        "icon": "GiCheckMark",
        "sfxFile": "sfx/ding.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "zuad",
    "harf": "ض",
    "soundFile": "zuad.mp3",
    "words": [
      {
        "word": "ضخیم",
        "imageFile": "zuad_01.jpg",
        "soundFile": "zuad_01.mp3",
        "videoFile": "zuad_11.webm",
        "sfxFile": "sfx/rock.mp3"
      },
      {
        "word": "ضرب",
        "imageFile": "zuad_02.jpg",
        "soundFile": "zuad_02.mp3",
        "icon": "GiPunch",
        "sfxFile": "sfx/hit.mp3"
      },
      {
        "word": "ضعیف",
        "imageFile": "zuad_03.jpg",
        "soundFile": "zuad_03.mp3",
        "videoFile": "zuad_13.webm",
        "icon": "GiCane",
        "sfxFile": "sfx/cough.mp3"
      },
      {
        "word": "ضمانت",
        "imageFile": "zuad_04.jpg",
        "soundFile": "zuad_04.mp3",
        "videoFile": "zuad_14.webm",
        "sfxFile": "sfx/stamp.mp3"
      },
      {
        "word": "ضیافت",
        "imageFile": "zuad_05.jpg",
        "soundFile": "zuad_05.mp3",
        "videoFile": "zuad_15.webm",
        "icon": "GiMeal",
        "sfxFile": "sfx/clink.mp3"
      },
      {
        "word": "ضائع",
        "imageFile": "zuad_06.jpg",
        "soundFile": "zuad_06.mp3",
        "videoFile": "zuad_16.webm",
        "icon": "GiTrashCan",
        "sfxFile": "sfx/throw.mp3"
      }
    ]
  },
  {
    "letter": "tuay",
    "harf": "ط",
    "soundFile": "tuay.mp3",
    "words": [
      {
        "word": "طشتری",
        "imageFile": "tuay_01.jpg",
        "soundFile": "tuay_01.mp3",
        "videoFile": "tuay_11.webm",
        "sfxFile": "sfx/clink.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "طوفان",
        "imageFile": "tuay_02.jpg",
        "soundFile": "tuay_02.mp3",
        "videoFile": "tuay_12.webm",
        "icon": "GiTornado",
        "sfxFile": "sfx/windstorm.mp3"
      },
      {
        "word": "طلباء",
        "imageFile": "tuay_03.jpg",
        "soundFile": "tuay_03.mp3",
        "videoFile": "tuay_13.webm",
        "icon": "GiGraduateCap",
        "sfxFile": "sfx/chatter.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "طوطا",
        "imageFile": "tuay_04.jpg",
        "soundFile": "tuay_04.mp3",
        "videoFile": "tuay_14.webm",
        "icon": "GiParrotHead",
        "sfxFile": "sfx/parrot.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "طعام",
        "imageFile": "tuay_05.jpg",
        "soundFile": "tuay_05.mp3",
        "videoFile": "tuay_15.webm",
        "icon": "GiMeal",
        "sfxFile": "sfx/dining.mp3"
      },
      {
        "word": "طویل",
        "imageFile": "tuay_06.jpg",
        "soundFile": "tuay_06.mp3",
        "videoFile": "tuay_16.webm",
        "icon": "GiHeight",
        "sfxFile": "sfx/stretch.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "zuay",
    "harf": "ظ",
    "soundFile": "zuay.mp3",
    "words": [
      {
        "word": "ظفر",
        "imageFile": "zuay_01.jpg",
        "soundFile": "zuay_01.mp3",
        "sfxFile": "sfx/victory.mp3"
      },
      {
        "word": "ظلمت",
        "imageFile": "zuay_02.jpg",
        "soundFile": "zuay_02.mp3",
        "videoFile": "zuay_12.webm",
        "icon": "GiDarkSquad",
        "sfxFile": "sfx/ominous.mp3"
      },
      {
        "word": "ظہر",
        "imageFile": "zuay_03.jpg",
        "soundFile": "zuay_03.mp3",
        "videoFile": "zuay_13.webm",
        "sfxFile": "sfx/sunrise.mp3"
      },
      {
        "word": "ظلم",
        "imageFile": "zuay_04.jpg",
        "soundFile": "zuay_04.mp3",
        "videoFile": "zuay_14.webm",
        "icon": "GiWhip",
        "sfxFile": "sfx/whip.mp3"
      },
      {
        "word": "ظہرانہ",
        "imageFile": "zuay_05.jpg",
        "soundFile": "zuay_05.mp3",
        "videoFile": "zuay_15.webm",
        "icon": "GiMeal",
        "sfxFile": "sfx/lunch-bell.mp3"
      },
      {
        "word": "ظروف",
        "imageFile": "zuay_06.jpg",
        "soundFile": "zuay_06.mp3",
        "videoFile": "zuay_16.webm",
        "icon": "GiCookingPot",
        "sfxFile": "sfx/clatter.mp3"
      }
    ]
  },
  {
    "letter": "ain",
    "harf": "ع",
    "soundFile": "ain.mp3",
    "words": [
      {
        "word": "عید",
        "imageFile": "ain_01.jpg",
        "soundFile": "ain_01.mp3",
        "videoFile": "ain_11.webm",
        "icon": "GiCrescentMoon",
        "sfxFile": "sfx/fireworks.mp3"
      },
      {
        "word": "عینک",
        "imageFile": "ain_02.jpg",
        "soundFile": "ain_02.mp3",
        "videoFile": "ain_12.webm",
        "icon": "GiSpectacles",
        "sfxFile": "sfx/glass-pop.mp3"
      },
      {
        "word": "عرفات",
        "imageFile": "ain_03.jpg",
        "soundFile": "ain_03.mp3",
        "videoFile": "ain_13.webm",
        "icon": "GiKaaba",
        "sfxFile": "sfx/crowd-prayer.mp3"
      },
      {
        "word": "عقاب",
        "imageFile": "ain_04.jpg",
        "soundFile": "ain_04.mp3",
        "videoFile": "ain_14.webm",
        "icon": "GiEagleHead",
        "sfxFile": "sfx/eagle.mp3"
      },
      {
        "word": "عہد",
        "imageFile": "ain_05.jpg",
        "soundFile": "ain_05.mp3",
        "videoFile": "ain_15.webm",
        "sfxFile": "sfx/pledge.mp3"
      },
      {
        "word": "عمارت",
        "imageFile": "ain_06.jpg",
        "soundFile": "ain_06.mp3",
        "videoFile": "ain_16.webm",
        "icon": "GiStoneTower",
        "sfxFile": "sfx/construction.mp3"
      }
    ]
  },
  {
    "letter": "ghain",
    "harf": "غ",
    "soundFile": "ghain.mp3",
    "words": [
      {
        "word": "غبار",
        "imageFile": "ghain_01.jpg",
        "soundFile": "ghain_01.mp3",
        "videoFile": "ghain_11.webm",
        "icon": "GiDustCloud",
        "sfxFile": "sfx/dust.mp3"
      },
      {
        "word": "غبارا",
        "imageFile": "ghain_02.jpg",
        "soundFile": "ghain_02.mp3",
        "icon": "GiBalloonDog",
        "sfxFile": "sfx/balloon-pop.mp3"
      },
      {
        "word": "غار",
        "imageFile": "ghain_03.jpg",
        "soundFile": "ghain_03.mp3",
        "videoFile": "ghain_13.webm",
        "icon": "GiCaveEntrance",
        "sfxFile": "sfx/echo.mp3"
      },
      {
        "word": "غزال",
        "imageFile": "ghain_04.jpg",
        "soundFile": "ghain_04.mp3",
        "videoFile": "ghain_14.webm",
        "icon": "GiDeer",
        "sfxFile": "sfx/deer.mp3"
      },
      {
        "word": "غلہ",
        "imageFile": "ghain_05.jpg",
        "soundFile": "ghain_05.mp3",
        "videoFile": "ghain_15.webm",
        "icon": "GiWheat",
        "sfxFile": "sfx/grain.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "غلاف",
        "imageFile": "ghain_06.jpg",
        "soundFile": "ghain_06.mp3",
        "sfxFile": "sfx/unroll.mp3"
      }
    ]
  },
  {
    "letter": "fay",
    "harf": "ف",
    "soundFile": "fay.mp3",
    "words": [
      {
        "word": "فوارہ",
        "imageFile": "fay_01.jpg",
        "soundFile": "fay_01.mp3",
        "videoFile": "fay_11.webm",
        "icon": "GiFountain",
        "sfxFile": "sfx/splash.mp3"
      },
      {
        "word": "فانوس",
        "imageFile": "fay_02.jpg",
        "soundFile": "fay_02.mp3",
        "icon": "GiLantern",
        "sfxFile": "sfx/lantern-glow.mp3"
      },
      {
        "word": "فرانس",
        "imageFile": "fay_03.jpg",
        "soundFile": "fay_03.mp3",
        "icon": "GiEiffelTower",
        "sfxFile": "sfx/crowd-paris.mp3"
      },
      {
        "word": "فاختہ",
        "imageFile": "fay_04.jpg",
        "soundFile": "fay_04.mp3",
        "videoFile": "fay_14.webm",
        "icon": "GiDove",
        "sfxFile": "sfx/dove.mp3"
      },
      {
        "word": "فالودہ",
        "imageFile": "fay_05.jpg",
        "soundFile": "fay_05.mp3",
        "sfxFile": "sfx/slurp.mp3"
      },
      {
        "word": "فالسہ",
        "imageFile": "fay_06.jpg",
        "soundFile": "fay_06.mp3",
        "videoFile": "fay_16.webm",
        "icon": "GiGrapes",
        "sfxFile": "sfx/fruit-drop.mp3"
      }
    ]
  },
  {
    "letter": "qaaf",
    "harf": "ق",
    "soundFile": "qaaf.mp3",
    "words": [
      {
        "word": "قالین",
        "imageFile": "qaaf_01.jpg",
        "soundFile": "qaaf_01.mp3",
        "sfxFile": "sfx/roll-carpet.mp3"
      },
      {
        "word": "قلم",
        "imageFile": "qaaf_02.jpg",
        "soundFile": "qaaf_02.mp3",
        "sfxFile": "sfx/write.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "قلعہ",
        "imageFile": "qaaf_03.jpg",
        "soundFile": "qaaf_03.mp3",
        "icon": "GiCastle",
        "sfxFile": "sfx/fort.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "قطار",
        "imageFile": "qaaf_04.jpg",
        "soundFile": "qaaf_04.mp3",
        "videoFile": "qaaf_14.webm",
        "sfxFile": "sfx/queue.mp3"
      },
      {
        "word": "قمیض",
        "imageFile": "qaaf_05.jpg",
        "soundFile": "qaaf_05.mp3",
        "sfxFile": "sfx/clothes.mp3"
      },
      {
        "word": "قینچی",
        "imageFile": "qaaf_06.jpg",
        "soundFile": "qaaf_06.mp3",
        "videoFile": "qaaf_16.webm",
        "icon": "GiScissors",
        "sfxFile": "sfx/snips.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "kaaf",
    "harf": "ک",
    "soundFile": "kaaf.mp3",
    "words": [
      {
        "word": "کاغذ",
        "imageFile": "kaaf_01.jpg",
        "soundFile": "kaaf_01.mp3",
        "videoFile": "kaaf_11.webm",
        "icon": "GiNotebook",
        "sfxFile": "sfx/page-flip.mp3"
      },
      {
        "word": "کتاب",
        "imageFile": "kaaf_02.jpg",
        "soundFile": "kaaf_02.mp3",
        "icon": "FaBook",
        "sfxFile": "sfx/page-flip.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "کراچی",
        "imageFile": "kaaf_03.jpg",
        "soundFile": "kaaf_03.mp3",
        "videoFile": "kaaf_13.webm",
        "sfxFile": "sfx/seagull.mp3"
      },
      {
        "word": "کبوتر",
        "imageFile": "kaaf_04.jpg",
        "soundFile": "kaaf_04.mp3",
        "videoFile": "kaaf_14.webm",
        "icon": "GiPigeon",
        "sfxFile": "sfx/pigeon.mp3"
      },
      {
        "word": "کدو",
        "imageFile": "kaaf_05.jpg",
        "soundFile": "kaaf_05.mp3",
        "sfxFile": "sfx/slice.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "کینو",
        "imageFile": "kaaf_06.jpg",
        "soundFile": "kaaf_06.mp3",
        "icon": "GiOrangeSlice",
        "sfxFile": "sfx/peel.mp3"
      }
    ]
  },
  {
    "letter": "gaaf",
    "harf": "گ",
    "soundFile": "gaaf.mp3",
    "words": [
      {
        "word": "گلاب",
        "imageFile": "gaaf_01.jpg",
        "soundFile": "gaaf_01.mp3",
        "icon": "GiRose",
        "sfxFile": "sfx/flower-bloom.mp3"
      },
      {
        "word": "گرہ",
        "imageFile": "gaaf_02.jpg",
        "soundFile": "gaaf_02.mp3",
        "icon": "GiRopeCoil",
        "sfxFile": "sfx/tie.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گاڑی",
        "imageFile": "gaaf_03.jpg",
        "soundFile": "gaaf_03.mp3",
        "videoFile": "gaaf_13.webm",
        "icon": "FaCar",
        "sfxFile": "sfx/car-start.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گلہری",
        "imageFile": "gaaf_04.jpg",
        "soundFile": "gaaf_04.mp3",
        "videoFile": "gaaf_14.webm",
        "icon": "GiSquirrel",
        "sfxFile": "sfx/squirrel.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گوبھی",
        "imageFile": "gaaf_05.jpg",
        "soundFile": "gaaf_05.mp3",
        "icon": "GiCabbage",
        "sfxFile": "sfx/veg-crunch.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گنا",
        "imageFile": "gaaf_06.jpg",
        "soundFile": "gaaf_06.mp3",
        "videoFile": "gaaf_16.webm",
        "icon": "GiSugarCane",
        "sfxFile": "sfx/sugarcane.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "laam",
    "harf": "ل",
    "soundFile": "laam.mp3",
    "words": [
      {
        "word": "لوہار",
        "imageFile": "laam_01.jpg",
        "soundFile": "laam_01.mp3",
        "videoFile": "laam_11.webm",
        "icon": "GiAnvil",
        "sfxFile": "sfx/hammer.mp3"
      },
      {
        "word": "لکڑی",
        "imageFile": "laam_02.jpg",
        "soundFile": "laam_02.mp3",
        "videoFile": "laam_12.webm",
        "icon": "GiLogs",
        "sfxFile": "sfx/wood-hit.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "لاہور",
        "imageFile": "laam_03.jpg",
        "soundFile": "laam_03.mp3",
        "sfxFile": "sfx/city-ambience.mp3"
      },
      {
        "word": "لنگور",
        "imageFile": "laam_04.jpg",
        "soundFile": "laam_04.mp3",
        "icon": "GiMonkey",
        "sfxFile": "sfx/monkey.mp3"
      },
      {
        "word": "لہسن",
        "imageFile": "laam_05.jpg",
        "soundFile": "laam_05.mp3",
        "icon": "GiGarlic",
        "sfxFile": "sfx/peel.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "لڈو",
        "imageFile": "laam_06.jpg",
        "soundFile": "laam_06.mp3",
        "sfxFile": "sfx/snack.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "meem",
    "harf": "م",
    "soundFile": "meem.mp3",
    "words": [
      {
        "word": "مچھیرا",
        "imageFile": "meem_01.jpg",
        "soundFile": "meem_01.mp3",
        "videoFile": "meem_11.webm",
        "icon": "GiFishingPole",
        "sfxFile": "sfx/water-splash.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "مینار",
        "imageFile": "meem_02.jpg",
        "soundFile": "meem_02.mp3",
        "sfxFile": "sfx/flag-flap.mp3"
      },
      {
        "word": "مدرسہ",
        "imageFile": "meem_03.jpg",
        "soundFile": "meem_03.mp3",
        "videoFile": "meem_13.webm",
        "icon": "GiSchoolBag",
        "sfxFile": "sfx/bell.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "مرغا",
        "imageFile": "meem_04.jpg",
        "soundFile": "meem_04.mp3",
        "videoFile": "meem_14.webm",
        "icon": "GiChicken",
        "sfxFile": "sfx/rooster.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "مولی",
        "imageFile": "meem_05.jpg",
        "soundFile": "meem_05.mp3",
        "icon": "GiRadish",
        "sfxFile": "sfx/crunch.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "مالٹا",
        "imageFile": "meem_06.jpg",
        "soundFile": "meem_06.mp3",
        "icon": "GiOrangeSlice",
        "sfxFile": "sfx/orange.mp3"
      }
    ]
  },
  {
    "letter": "noon",
    "harf": "ن",
    "soundFile": "noon.mp3",
    "words": [
      {
        "word": "ناخن",
        "imageFile": "noon_01.jpg",
        "soundFile": "noon_01.mp3",
        "sfxFile": "sfx/nail.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "نلکا",
        "imageFile": "noon_02.jpg",
        "soundFile": "noon_02.mp3",
        "videoFile": "noon_12.webm",
        "icon": "GiWaterDrop",
        "sfxFile": "sfx/water-drop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "نہر",
        "imageFile": "noon_03.jpg",
        "soundFile": "noon_03.mp3",
        "videoFile": "noon_13.webm",
        "icon": "GiRiver",
        "sfxFile": "sfx/stream.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ناگ",
        "imageFile": "noon_04.jpg",
        "soundFile": "noon_04.mp3",
        "videoFile": "noon_14.webm",
        "icon": "GiSnake",
        "sfxFile": "sfx/hiss.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ناریل",
        "imageFile": "noon_05.jpg",
        "soundFile": "noon_05.mp3",
        "icon": "GiCoconut",
        "sfxFile": "sfx/coconut.mp3"
      },
      {
        "word": "ناشپاتی",
        "imageFile": "noon_06.jpg",
        "soundFile": "noon_06.mp3",
        "icon": "GiPear",
        "sfxFile": "sfx/fruit-bite.mp3"
      }
    ]
  },
  {
    "letter": "wow",
    "harf": "و",
    "soundFile": "wow.mp3",
    "words": [
      {
        "word": "وضو",
        "imageFile": "wow_01.jpg",
        "soundFile": "wow_01.mp3",
        "videoFile": "wow_11.webm",
        "icon": "GiWaterSplash",
        "sfxFile": "sfx/ablution.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ووٹ",
        "imageFile": "wow_02.jpg",
        "soundFile": "wow_02.mp3",
        "videoFile": "wow_12.webm",
        "icon": "GiVote",
        "sfxFile": "sfx/stamp.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "وادی",
        "imageFile": "wow_03.jpg",
        "soundFile": "wow_03.mp3",
        "videoFile": "wow_13.webm",
        "icon": "GiValley",
        "sfxFile": "sfx/birds.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "وقت",
        "imageFile": "wow_04.jpg",
        "soundFile": "wow_04.mp3",
        "icon": "GiAlarmClock",
        "sfxFile": "sfx/tick.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ورزش",
        "imageFile": "wow_05.jpg",
        "soundFile": "wow_05.mp3",
        "videoFile": "wow_15.webm",
        "icon": "GiMuscleUp",
        "sfxFile": "sfx/whistle.mp3"
      },
      {
        "word": "وزن",
        "imageFile": "wow_06.jpg",
        "soundFile": "wow_06.mp3",
        "videoFile": "wow_16.webm",
        "icon": "GiWeight",
        "sfxFile": "sfx/weight-drop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "hey",
    "harf": "ہ",
    "soundFile": "hey.mp3",
    "words": [
      {
        "word": "ہاتھ",
        "imageFile": "hey_01.jpg",
        "soundFile": "hey_01.mp3",
        "videoFile": "hey_11.webm",
        "icon": "GiHand",
        "sfxFile": "sfx/clap.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ہیرا",
        "imageFile": "hey_02.jpg",
        "soundFile": "hey_02.mp3",
        "videoFile": "hey_12.webm",
        "icon": "GiGemPendant",
        "sfxFile": "sfx/shimmer.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ہجوم",
        "imageFile": "hey_03.jpg",
        "soundFile": "hey_03.mp3",
        "sfxFile": "sfx/crowd.mp3"
      },
      {
        "word": "ہاتھی",
        "imageFile": "hey_04.jpg",
        "soundFile": "hey_04.mp3",
        "icon": "GiElephant",
        "sfxFile": "sfx/elephant.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ہلدی",
        "imageFile": "hey_05.jpg",
        "soundFile": "hey_05.mp3",
        "sfxFile": "sfx/spice.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ہل",
        "imageFile": "hey_06.jpg",
        "soundFile": "hey_06.mp3",
        "icon": "GiPlow",
        "sfxFile": "sfx/plow.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "hamza",
    "harf": "ء",
    "soundFile": "hamza.mp3",
    "words": [
      {
        "word": "حلوائی",
        "imageFile": "hamza_01.jpg",
        "soundFile": "hamza_01.mp3",
        "icon": "GiChefToque",
        "sfxFile": "sfx/serve.mp3",
        "categories": [
          "person",
          "occupation",
          "food"
        ]
      },
      {
        "word": "آئینہ",
        "imageFile": "hamza_02.jpg",
        "soundFile": "hamza_02.mp3",
        "icon": "GiMirrorMirror",
        "sfxFile": "sfx/mirror-shimmer.mp3",
        "categories": [
          "object",
          "household"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چائے",
        "imageFile": "hamza_03.jpg",
        "soundFile": "hamza_03.mp3",
        "icon": "GiTeapot",
        "sfxFile": "sfx/tea.mp3"
      },
      {
        "word": "دائرہ",
        "imageFile": "hamza_04.jpg",
        "soundFile": "hamza_04.mp3",
        "videoFile": "hamza_14.webm",
        "sfxFile": "sfx/spin.mp3"
      },
      {
        "word": "ترئی",
        "imageFile": "hamza_05.jpg",
        "soundFile": "hamza_05.mp3",
        "sfxFile": "sfx/slice.mp3",
        "categories": [
          "vegetable",
          "food"
        ],
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "روئی",
        "imageFile": "hamza_06.jpg",
        "soundFile": "hamza_06.mp3",
        "videoFile": "hamza_16.webm",
        "icon": "GiCottonFlower",
        "sfxFile": "sfx/soft-pop.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "yay",
    "harf": "ی",
    "soundFile": "yay.mp3",
    "words": [
      {
        "word": "یاقوت",
        "imageFile": "yay_01.jpg",
        "soundFile": "yay_01.mp3",
        "icon": "GiRuby",
        "sfxFile": "sfx/gem.mp3"
      },
      {
        "word": "یکہ",
        "imageFile": "yay_02.jpg",
        "soundFile": "yay_02.mp3",
        "videoFile": "yay_12.webm",
        "icon": "GiWagon",
        "sfxFile": "sfx/horse-cart.mp3"
      },
      {
        "word": "یروشلم",
        "imageFile": "yay_03.jpg",
        "soundFile": "yay_03.mp3",
        "videoFile": "yay_13.webm",
        "sfxFile": "sfx/temple-bell.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "یاک",
        "imageFile": "yay_04.jpg",
        "soundFile": "yay_04.mp3",
        "icon": "GiBuffaloHead",
        "sfxFile": "sfx/yak.mp3"
      },
      {
        "word": "یلغار",
        "imageFile": "yay_05.jpg",
        "soundFile": "yay_05.mp3",
        "videoFile": "yay_15.webm",
        "icon": "GiCrossedSwords",
        "sfxFile": "sfx/battle.mp3"
      },
      {
        "word": "یخ",
        "imageFile": "yay_06.jpg",
        "soundFile": "yay_06.mp3",
        "icon": "GiIciclesAura",
        "sfxFile": "sfx/freeze.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "yey",
    "harf": "ے",
    "soundFile": "yey.mp3",
    "words": [
      {
        "word": "آگے",
        "imageFile": "yey_01.jpg",
        "soundFile": "yey_01.mp3",
        "videoFile": "yey_11.webm",
        "icon": "GiArrowDunk",
        "sfxFile": "sfx/arrow.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "غبارے",
        "imageFile": "yey_02.jpg",
        "soundFile": "yey_02.mp3",
        "icon": "GiBalloonDog",
        "sfxFile": "sfx/balloon-pop.mp3"
      },
      {
        "word": "نیچے",
        "imageFile": "yey_03.jpg",
        "soundFile": "yey_03.mp3",
        "videoFile": "yey_13.webm",
        "sfxFile": "sfx/drop.mp3"
      },
      {
        "word": "گائے",
        "imageFile": "yey_04.jpg",
        "soundFile": "yey_04.mp3",
        "videoFile": "yey_14.webm",
        "icon": "GiCow",
        "sfxFile": "sfx/cow.mp3"
      },
      {
        "word": "نمک پارے",
        "imageFile": "yey_05.jpg",
        "soundFile": "yey_05.mp3",
        "sfxFile": "sfx/snack-crunch.mp3"
      },
      {
        "word": "چائے",
        "imageFile": "yey_06.jpg",
        "soundFile": "yey_06.mp3",
        "icon": "GiTeapot",
        "sfxFile": "sfx/tea.mp3"
      }
    ]
  },
  {
    "letter": "bha",
    "harf": "بھ",
    "soundFile": "bha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "بھینس",
        "imageFile": "bha_01.jpg",
        "soundFile": "bha_01.mp3",
        "videoFile": "bha_11.webm",
        "icon": "GiBuffalo",
        "sfxFile": "sfx/buffalo.mp3"
      },
      {
        "word": "بھوسہ",
        "imageFile": "bha_02.jpg",
        "soundFile": "bha_02.mp3",
        "videoFile": "bha_12.webm",
        "icon": "GiHayfork",
        "sfxFile": "sfx/hay-rustle.mp3"
      },
      {
        "word": "بھنور",
        "imageFile": "bha_03.jpg",
        "soundFile": "bha_03.mp3",
        "videoFile": "bha_13.webm",
        "sfxFile": "sfx/swirl.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "بھٹا",
        "imageFile": "bha_04.jpg",
        "soundFile": "bha_04.mp3",
        "videoFile": "bha_14.webm",
        "sfxFile": "sfx/fire.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "بھنڈی",
        "imageFile": "bha_05.jpg",
        "soundFile": "bha_05.mp3",
        "videoFile": "bha_15.webm",
        "sfxFile": "sfx/veg-cut.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "بھٹی",
        "imageFile": "bha_06.jpg",
        "soundFile": "bha_06.mp3",
        "videoFile": "bha_16.webm",
        "icon": "GiFireplace",
        "sfxFile": "sfx/furnace.mp3"
      }
    ]
  },
  {
    "letter": "pha",
    "harf": "پھ",
    "soundFile": "pha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "پھول",
        "imageFile": "pha_01.jpg",
        "soundFile": "pha_01.mp3",
        "videoFile": "pha_11.webm",
        "icon": "GiFlowerPot",
        "sfxFile": "sfx/flower.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پھلواری",
        "imageFile": "pha_02.jpg",
        "soundFile": "pha_02.mp3",
        "sfxFile": "sfx/bloom.mp3"
      },
      {
        "word": "پھلانگنا",
        "imageFile": "pha_03.jpg",
        "soundFile": "pha_03.mp3",
        "videoFile": "pha_13.webm",
        "sfxFile": "sfx/jump.mp3"
      },
      {
        "word": "پھسلنا",
        "imageFile": "pha_04.jpg",
        "soundFile": "pha_04.mp3",
        "videoFile": "pha_14.webm",
        "icon": "GiSlipperySlopes",
        "sfxFile": "sfx/slip.mp3"
      },
      {
        "word": "پھرکی",
        "imageFile": "pha_05.jpg",
        "soundFile": "pha_05.mp3",
        "videoFile": "pha_15.webm",
        "icon": "GiPaperWindmill",
        "sfxFile": "sfx/spin.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "پھاٹک",
        "imageFile": "pha_06.jpg",
        "soundFile": "pha_06.mp3",
        "videoFile": "pha_16.webm",
        "icon": "GiGate",
        "sfxFile": "sfx/gate-creak.mp3"
      }
    ]
  },
  {
    "letter": "tha",
    "harf": "تھ",
    "soundFile": "tha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "تھیلا",
        "imageFile": "tha_01.jpg",
        "soundFile": "tha_01.mp3",
        "icon": "GiShoppingBag",
        "sfxFile": "sfx/bag.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "تھوڑا",
        "imageFile": "tha_02.jpg",
        "soundFile": "tha_02.mp3",
        "sfxFile": "sfx/tick.mp3"
      },
      {
        "word": "تھانہ",
        "imageFile": "tha_03.jpg",
        "soundFile": "tha_03.mp3",
        "icon": "GiPoliceBadge",
        "sfxFile": "sfx/siren.mp3"
      },
      {
        "word": "تھان",
        "imageFile": "tha_04.jpg",
        "soundFile": "tha_04.mp3",
        "videoFile": "tha_14.webm",
        "icon": "GiFabric",
        "sfxFile": "sfx/fabric-rustle.mp3"
      },
      {
        "word": "تھامنا",
        "imageFile": "tha_05.jpg",
        "soundFile": "tha_05.mp3",
        "videoFile": "tha_15.webm",
        "icon": "GiHandGrab",
        "sfxFile": "sfx/grab.mp3"
      },
      {
        "word": "تھالی",
        "imageFile": "tha_06.jpg",
        "soundFile": "tha_06.mp3",
        "sfxFile": "sfx/clink.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "ttha",
    "harf": "ٹھ",
    "soundFile": "ttha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "ٹھیلا",
        "imageFile": "ttha_01.jpg",
        "soundFile": "ttha_01.mp3",
        "videoFile": "ttha_11.webm",
        "icon": "GiWagon",
        "sfxFile": "sfx/cart-roll.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹھیک",
        "imageFile": "ttha_02.jpg",
        "soundFile": "ttha_02.mp3",
        "videoFile": "ttha_12.webm",
        "icon": "GiCheckMark",
        "sfxFile": "sfx/ding.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "ٹھٹھہ",
        "imageFile": "ttha_03.jpg",
        "soundFile": "ttha_03.mp3",
        "videoFile": "ttha_13.webm",
        "sfxFile": "sfx/street.mp3"
      },
      {
        "word": "ٹھوس",
        "imageFile": "ttha_04.jpg",
        "soundFile": "ttha_04.mp3",
        "videoFile": "ttha_14.webm",
        "icon": "GiStoneBlock",
        "sfxFile": "sfx/stone-hit.mp3"
      },
      {
        "word": "ٹھونکنا",
        "imageFile": "ttha_05.jpg",
        "soundFile": "ttha_05.mp3",
        "videoFile": "ttha_15.webm",
        "sfxFile": "sfx/hammer.mp3"
      },
      {
        "word": "ٹھپا",
        "imageFile": "ttha_06.jpg",
        "soundFile": "ttha_06.mp3",
        "icon": "GiStomp",
        "sfxFile": "sfx/stamp.mp3"
      }
    ]
  },
  {
    "letter": "jha",
    "harf": "جھ",
    "soundFile": "jha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "جھاڑو",
        "imageFile": "jha_01.jpg",
        "soundFile": "jha_01.mp3",
        "videoFile": "jha_11.webm",
        "icon": "GiBroom",
        "sfxFile": "sfx/sweep.mp3"
      },
      {
        "word": "جھنڈا",
        "imageFile": "jha_02.jpg",
        "soundFile": "jha_02.mp3",
        "videoFile": "jha_12.webm",
        "icon": "GiFlag",
        "sfxFile": "sfx/flag.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "جھولا",
        "imageFile": "jha_03.jpg",
        "soundFile": "jha_03.mp3",
        "videoFile": "jha_13.webm",
        "icon": "GiSwing",
        "sfxFile": "sfx/swing.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "جھینگا",
        "imageFile": "jha_04.jpg",
        "soundFile": "jha_04.mp3",
        "videoFile": "jha_14.webm",
        "icon": "GiShrimp",
        "sfxFile": "sfx/snap.mp3"
      },
      {
        "word": "جھاگ",
        "imageFile": "jha_05.jpg",
        "soundFile": "jha_05.mp3",
        "videoFile": "jha_15.webm",
        "icon": "GiFoamyDisc",
        "sfxFile": "sfx/foam.mp3"
      },
      {
        "word": "جھیل",
        "imageFile": "jha_06.jpg",
        "soundFile": "jha_06.mp3",
        "videoFile": "jha_16.webm",
        "icon": "GiWaterSplash",
        "sfxFile": "sfx/lake.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "chha",
    "harf": "چھ",
    "soundFile": "chha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "چھڑی",
        "imageFile": "chha_01.jpg",
        "soundFile": "chha_01.mp3",
        "icon": "GiMagicStaff",
        "sfxFile": "sfx/stick.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چھپکلی",
        "imageFile": "chha_02.jpg",
        "soundFile": "chha_02.mp3",
        "videoFile": "chha_12.webm",
        "sfxFile": "sfx/lizard.mp3"
      },
      {
        "word": "چھلکا",
        "imageFile": "chha_03.jpg",
        "soundFile": "chha_03.mp3",
        "videoFile": "chha_13.webm",
        "icon": "GiPeelApple",
        "sfxFile": "sfx/peel.mp3"
      },
      {
        "word": "چھپنا",
        "imageFile": "chha_04.jpg",
        "soundFile": "chha_04.mp3",
        "videoFile": "chha_14.webm",
        "icon": "GiHidden",
        "sfxFile": "sfx/hide.mp3"
      },
      {
        "word": "چھلانگ",
        "imageFile": "chha_05.jpg",
        "soundFile": "chha_05.mp3",
        "videoFile": "chha_15.webm",
        "icon": "GiJumpAcross",
        "sfxFile": "sfx/jump.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "چھتری",
        "imageFile": "chha_06.jpg",
        "soundFile": "chha_06.mp3",
        "icon": "GiUmbrella",
        "sfxFile": "sfx/umbrella.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "dha",
    "harf": "دھ",
    "soundFile": "dha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "دھاگہ",
        "imageFile": "dha_01.jpg",
        "soundFile": "dha_01.mp3",
        "sfxFile": "sfx/thread.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "دھان",
        "imageFile": "dha_02.jpg",
        "soundFile": "dha_02.mp3",
        "videoFile": "dha_12.webm",
        "icon": "GiWheat",
        "sfxFile": "sfx/grain.mp3"
      },
      {
        "word": "دھکا",
        "imageFile": "dha_03.jpg",
        "soundFile": "dha_03.mp3",
        "videoFile": "dha_13.webm",
        "sfxFile": "sfx/push.mp3"
      },
      {
        "word": "دھماکہ",
        "imageFile": "dha_04.jpg",
        "soundFile": "dha_04.mp3",
        "videoFile": "dha_14.webm",
        "sfxFile": "sfx/explosion.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "دھنک",
        "imageFile": "dha_05.jpg",
        "soundFile": "dha_05.mp3",
        "icon": "GiRainbowStar",
        "sfxFile": "sfx/rainbow.mp3"
      },
      {
        "word": "دھواں",
        "imageFile": "dha_06.jpg",
        "soundFile": "dha_06.mp3",
        "videoFile": "dha_16.webm",
        "icon": "GiSmokeBomb",
        "sfxFile": "sfx/smoke.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "ddha",
    "harf": "ڈھ",
    "soundFile": "ddha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "ڈھانپنا",
        "imageFile": "ddha_01.jpg",
        "soundFile": "ddha_01.mp3",
        "videoFile": "ddha_11.webm",
        "sfxFile": "sfx/cover.mp3"
      },
      {
        "word": "ڈھانا",
        "imageFile": "ddha_02.jpg",
        "soundFile": "ddha_02.mp3",
        "videoFile": "ddha_12.webm",
        "icon": "GiDestruction",
        "sfxFile": "sfx/demolish.mp3"
      },
      {
        "word": "ڈھکنا",
        "imageFile": "ddha_03.jpg",
        "soundFile": "ddha_03.mp3",
        "videoFile": "ddha_13.webm",
        "sfxFile": "sfx/lock.mp3"
      },
      {
        "word": "ڈھلان",
        "imageFile": "ddha_04.jpg",
        "soundFile": "ddha_04.mp3",
        "videoFile": "ddha_14.webm",
        "icon": "GiMountainRoad",
        "sfxFile": "sfx/slope.mp3"
      },
      {
        "word": "ڈھیر",
        "imageFile": "ddha_05.jpg",
        "soundFile": "ddha_05.mp3",
        "icon": "GiStonePile",
        "sfxFile": "sfx/rockfall.mp3"
      },
      {
        "word": "ڈھیلا",
        "imageFile": "ddha_06.jpg",
        "soundFile": "ddha_06.mp3",
        "videoFile": "ddha_16.webm",
        "sfxFile": "sfx/loosen.mp3"
      }
    ]
  },
  {
    "letter": "kha",
    "harf": "کھ",
    "soundFile": "kha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "کھڑکی",
        "imageFile": "kha_01.jpg",
        "soundFile": "kha_01.mp3",
        "videoFile": "kha_11.webm",
        "icon": "GiWindow",
        "sfxFile": "sfx/window.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "کھلاڑی",
        "imageFile": "kha_02.jpg",
        "soundFile": "kha_02.mp3",
        "videoFile": "kha_12.webm",
        "icon": "GiSoccerBall",
        "sfxFile": "sfx/kick.mp3"
      },
      {
        "word": "کھیت",
        "imageFile": "kha_03.jpg",
        "soundFile": "kha_03.mp3",
        "icon": "GiFarmer",
        "sfxFile": "sfx/farm.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "کُھر",
        "imageFile": "kha_04.jpg",
        "soundFile": "kha_04.mp3",
        "icon": "GiHorseshoe",
        "sfxFile": "sfx/hoof.mp3"
      },
      {
        "word": "کھیر",
        "imageFile": "kha_05.jpg",
        "soundFile": "kha_05.mp3",
        "sfxFile": "sfx/kheer.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "کھیرا",
        "imageFile": "kha_06.jpg",
        "soundFile": "kha_06.mp3",
        "videoFile": "kha_16.webm",
        "icon": "GiCucumber",
        "sfxFile": "sfx/cut.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  },
  {
    "letter": "gha",
    "harf": "گھ",
    "soundFile": "gha.mp3",
    "isCompound":true,
    "words": [
      {
        "word": "گھاٹ",
        "imageFile": "gha_01.jpg",
        "soundFile": "gha_01.mp3",
        "videoFile": "gha_11.webm",
        "icon": "GiDock",
        "sfxFile": "sfx/water-dock.mp3"
      },
      {
        "word": "گھاس",
        "imageFile": "gha_02.jpg",
        "soundFile": "gha_02.mp3",
        "videoFile": "gha_12.webm",
        "icon": "GiGrass",
        "sfxFile": "sfx/grass.mp3"
      },
      {
        "word": "گھڑا",
        "imageFile": "gha_03.jpg",
        "soundFile": "gha_03.mp3",
        "icon": "GiAmphora",
        "sfxFile": "sfx/pot.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گھڑی",
        "imageFile": "gha_04.jpg",
        "soundFile": "gha_04.mp3",
        "videoFile": "gha_14.webm",
        "icon": "FaClock",
        "sfxFile": "sfx/clock-tick.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      },
      {
        "word": "گھوڑا",
        "imageFile": "gha_05.jpg",
        "soundFile": "gha_05.mp3",
        "videoFile": "gha_15.webm",
        "icon": "GiHorseHead",
        "sfxFile": "sfx/horse.mp3"
      },
      {
        "word": "گھونگا",
        "imageFile": "gha_06.jpg",
        "soundFile": "gha_06.mp3",
        "videoFile": "gha_16.webm",
        "icon": "GiSnail",
        "sfxFile": "sfx/snail.mp3",
        "games": [
          "PicturePuzzle",
          "MemoryGame",
          "WordMatching",
          "SoundMatching",
          "QuickQuiz",
          "AlphabetOrdering"
        ]
      }
    ]
  }
];

export default alphabetData;